// Environment configuration for the visualizer frontend
const getApiBaseUrl = () => {
  // Debug logging
  console.log('🔍 Visualizer Environment Debug:', {
    PROD: import.meta.env.PROD,
    DEV: import.meta.env.DEV,
    MODE: import.meta.env.MODE,
    hostname: window.location.hostname,
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL
  })
  
  // Check if we have environment variable
  if (import.meta.env.VITE_API_BASE_URL) {
    console.log('🌐 Using VITE_API_BASE_URL:', import.meta.env.VITE_API_BASE_URL)
    return import.meta.env.VITE_API_BASE_URL
  }
  
  // Production detection
  if (import.meta.env.PROD || window.location.hostname.includes('serviceflow-pro.com')) {
    console.log('🚀 Visualizer using PRODUCTION API URL')
    return 'https://api.serviceflow-pro.com'
  }
  
  // Development fallback - use main API server
  console.log('🛠️ Visualizer using DEVELOPMENT API URL')
  return 'http://localhost:3001'
}

const getAiVisionBaseUrl = () => {
  // Check if we have environment variable
  if (import.meta.env.VITE_AI_VISION_URL) {
    console.log('🌐 Using VITE_AI_VISION_URL:', import.meta.env.VITE_AI_VISION_URL)
    return import.meta.env.VITE_AI_VISION_URL
  }
  
  // Production detection
  if (import.meta.env.PROD || window.location.hostname.includes('serviceflow-pro.com')) {
    return 'https://ai-vision.serviceflow-pro.com'
  }
  
  // Development fallback
  return 'http://localhost:8000'
}

export const config = {
  // API URLs
  apiBaseUrl: getApiBaseUrl(),
  aiVisionUrl: getAiVisionBaseUrl(),
  
  // Feature flags
  features: {
    aiAnalysis: import.meta.env.VITE_ENABLE_AI_ANALYSIS !== 'false',
    aiVision: import.meta.env.VITE_ENABLE_AI_VISION === 'false', // Disabled by default until service is stable
    backendSync: import.meta.env.VITE_ENABLE_BACKEND_SYNC !== 'false',
    userAuth: import.meta.env.VITE_ENABLE_USER_AUTH === 'true',
    mockApi: import.meta.env.VITE_MOCK_API === 'true',
  },
  
  // Development settings
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  debugMode: import.meta.env.VITE_DEBUG_MODE === 'true' || import.meta.env.DEV,
  
  // App metadata
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  buildTime: import.meta.env.VITE_BUILD_TIME || new Date().toISOString(),
  
  // Analytics
  analytics: {
    id: import.meta.env.VITE_ANALYTICS_ID,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  },
  
  // Timeouts and limits
  api: {
    timeout: 30000, // 30 seconds
    retries: 3,
    retryDelay: 1000, // 1 second
  },
  
  upload: {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  },
  
  // 3D Scene settings
  scene: {
    maxObjects: 50,
    renderDistance: 1000,
    shadowMapSize: 2048,
    antialias: true,
  },
}

// Utility functions
export const isFeatureEnabled = (feature: keyof typeof config.features): boolean => {
  return config.features[feature]
}

export const getApiUrl = (endpoint: string): string => {
  return `${config.apiBaseUrl}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`
}

export const getAiVisionUrl = (endpoint: string): string => {
  return `${config.aiVisionUrl}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`
}

export const log = (...args: any[]): void => {
  if (config.debugMode) {
    console.log('[Visualizer]', ...args)
  }
}

export const logError = (...args: any[]): void => {
  if (config.debugMode) {
    console.error('[Visualizer Error]', ...args)
  }
}

export default config
